export default __webpack_public_path__ + "static/media/rating_web-lg@1x.d654516d.jpg";